import { Injectable } from "@angular/core";
import { Subject } from "rxjs";

@Injectable({providedIn:'root'})
export class SpinnerService {
    public loading = new Subject();
    
    constructor(){}
}